import { useRedux } from "hooks";
import { TaskStatus, WorkPlaceCatFilter, WorkPlaceTagFilter, WpSliceData } from "../../../redux/workplace/wpTypes";
import { createSelector } from "reselect";
import { Utils } from "helpers/utils";
import { clearAllFilterAction, setFilterSelected, setTaskStatusFilter } from "../../../redux/workplace/wpActions";
import { TABS, WpModes } from "../../../constants";

interface WorkplaceFilterSelProps {
  // filterSel: WorkPlaceFilterSel[];
  onFilterDel: (tagId: number) => void;
  allTags: WorkPlaceCatFilter[];
  wpMode: WpModes;
}

const WorkplaceFilterSel = ({ wpMode, allTags, onFilterDel }: WorkplaceFilterSelProps) => {
  const { dispatch, useAppSelector } = useRedux();

  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (state: any) => state.Layout,
    (wp: WpSliceData, layout) => ({
      tagFilterSelected: wpMode == WpModes.Workplace ? wp.tagFilterSelected : wp.tagFilterSelectedTk,
      taskStatusFilter: wp.taskStatusFilter,
      activeTab: layout.activeTab,
    })
  );
  // Inside your component
  const { tagFilterSelected, taskStatusFilter, activeTab } = useAppSelector(storeData);
  // console.log('tagFilterSelected:', tagFilterSelected);

  const selTags = allTags.flatMap(cat => (cat.tags ?? []).filter(tag => tag.selected))
  const onFilterTaskStatusDel = (taskStatus: TaskStatus) => {
    dispatch(setTaskStatusFilter(taskStatus));
  }
  const onClearAllFilter = () => {
    dispatch(clearAllFilterAction(wpMode));
  }
  return (
    <div className="accordion-body position-relative ps-1 pb-1 " style={{ paddingTop: "0px", fontSize: "0.95em"/*, minHeight:"30px"*/ }}>
      {/* {allTags.map((cat: WorkPlaceCatFilter, index: number) =>
        (cat.tags ?? []).filter(t => t.selected).map((tag: WorkPlaceTagFilter, index2: number) => (
          <span key={index + '.' + index2} className="wp-tag-filter hand"
            style={{ color: cat.faColor, backgroundColor: cat.bgColor }}
            onClick={() => onFilterDel(tag.tagId)}
          >
            <i className={cat.faIcon}></i> {tag.name}
          </span>
        ))
      )} */}
      {activeTab == TABS.TASK && taskStatusFilter.map((eachItem, index) => (
        <span
          className={"wp-tag-filter hand mb-2 hover badge-task-status-sel badge-task-status-" + TaskStatus[eachItem].toLowerCase()}
          onClick={(e) => onFilterTaskStatusDel(eachItem)}
        >
          {Utils.GetTaskStatusIcon(eachItem)}{Utils.GetTaskStatusText(eachItem)}
        </span>
      ))}

      {tagFilterSelected.map((tag: WorkPlaceTagFilter, index: number) => (
        <span key={index} className="wp-tag-filter hand"
          style={{ color: tag.faColor ?? "black", backgroundColor: tag.bgColor ?? "white" }}
          onClick={() => onFilterDel(tag.tagId)}
        >
          <i className={tag.faIcon ?? "fas fa-at"}></i> {tag.name}
        </span>

      ))}

      {(tagFilterSelected.length + (activeTab == TABS.TASK ? taskStatusFilter.length : 0)) > 1 && (
        <span className="wp-tag-filter hand mb-2 hover badge-task-status-cancel" onClick={onClearAllFilter}>❌</span>
      )}

      {/* <span className="erp-tag">ลวด GI</span>
      <span className="erp-tag">ลวดเชื่อม</span>
      <span className="erp-tag">ลวดผูกเหล็ก</span>
      <span className="erp-tag">ไวร์เมชแผง</span>
      <span className="erp-tag">เหล็กฉากกัลวาไนซ์</span>
      <span className="erp-tag">เหล็กปลอก</span>
      <span className="erp-tag">เหล็กรางรถไฟ</span> */}
    </div>
  );
}

export default WorkplaceFilterSel;